import React from 'react';
import createUseContext from 'constate';

const ACTION_TYPE = {
  SET_DICTIONARY: 'SET_DICTIONARY',
};

const initialState = {
  fridgeDictionary: {},
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPE.SET_DICTIONARY:
      return {
        fridgeDictionary: {
          ...state.fridgeDictionary,
          ...action.payload.dictionary,
        },
      };
    default:
      throw new Error();
  }
};

const useFridge = () => {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const {
    fridgeDictionary,
  } = state;
  const setFridgeDictionary = (dictionary) => {
    dispatch({
      type: ACTION_TYPE.SET_DICTIONARY,
      payload: {
        dictionary,
      },
    });
  };

  return {
    fridgeDictionary,
    setFridgeDictionary,
  };
};

const [FridgeProvider, useFridgeContext] = createUseContext(useFridge);

export {
  FridgeProvider,
  useFridgeContext,
};
